const stripAccents = (value = "") =>
  String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const normalizeSupportMessage = (value = "") =>
  stripAccents(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const sanitizeChatMessage = (value = "") =>
  String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/[\u0000-\u001f\u007f]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 800);

const topic = ({
  id,
  category,
  icon,
  keywords,
  responsibleRole,
  suggestedQuestionKeys
}) => ({
  id,
  titleKey: `${id}Title`,
  category,
  icon,
  keywords,
  shortDescriptionKey: `${id}Short`,
  automaticMessageKey: `${id}Message`,
  suggestedQuestionKeys,
  responsibleTopic: id,
  responsibleRole
});

export const supportKnowledgeBase = [
  topic({
    id: "elakay",
    category: "platform",
    icon: "info",
    keywords: ["elakay", "marketplace", "plateforme", "platform", "why elakay", "pourquoi", "fonctionne", "avantages", "countries", "pays", "languages", "langues", "protection"],
    responsibleRole: ["Support", "Administrator", "Family"],
    suggestedQuestionKeys: ["suggestElakaySecurity", "suggestCreateAccount", "suggestContactSupport"]
  }),
  topic({
    id: "account",
    category: "account",
    icon: "account",
    keywords: ["account", "compte", "signup", "sign up", "creer compte", "créer compte", "verify account", "verifier", "vérifier", "profil", "profile", "password", "mot de passe", "delete account", "supprimer compte", "settings", "parametres"],
    responsibleRole: ["CustomerService", "Support", "Administrator"],
    suggestedQuestionKeys: ["suggestVerifyAccount", "suggestChangePassword", "suggestContactSupport"]
  }),
  topic({
    id: "royalty",
    category: "role",
    icon: "crown",
    keywords: ["royalty", "royale", "royal", "user royale", "recompense", "récompense", "avantage royal"],
    responsibleRole: ["Associate", "Administrator"],
    suggestedQuestionKeys: ["suggestRoyaltyConditions", "suggestRoleSteps", "suggestContactRole"]
  }),
  topic({
    id: "seller",
    category: "role",
    icon: "store",
    keywords: ["seller", "vendeur", "shop", "boutique", "store", "sell", "vendre", "produit", "add product", "ajouter produit", "edit product", "modifier produit", "delete product", "supprimer produit", "promotion", "wallet seller", "withdraw", "retrait", "gerer commandes", "gérer commandes"],
    responsibleRole: ["Seller", "Administrator"],
    suggestedQuestionKeys: ["suggestCreateShop", "suggestSellerDocuments", "suggestAddProducts", "suggestSellerPayments", "suggestContactSeller"]
  }),
  topic({
    id: "provider",
    category: "role",
    icon: "provider",
    keywords: ["provider", "producer", "producteur", "fournisseur", "wholesale", "gros", "sell wholesale", "vendre en gros", "production", "supply sellers", "fournir sellers"],
    responsibleRole: ["Provider", "Administrator"],
    suggestedQuestionKeys: ["suggestProviderConditions", "suggestWholesale", "suggestContactProvider"]
  }),
  topic({
    id: "associate",
    category: "role",
    icon: "shield",
    keywords: ["associate", "associe", "associé", "mission", "missions", "reward", "recompense", "récompense", "partner", "partenaire"],
    responsibleRole: ["Associate", "Administrator"],
    suggestedQuestionKeys: ["suggestAssociateMissions", "suggestAssociateRewards", "suggestContactAssociate"]
  }),
  topic({
    id: "investor",
    category: "role",
    icon: "investment",
    keywords: ["investor", "investment", "investisseur", "investissement", "investir", "contract", "contrat", "revenu", "revenus", "historique", "project", "projet", "paiement investor"],
    responsibleRole: ["Investment", "Administrator", "Family"],
    suggestedQuestionKeys: ["suggestInvestmentProjects", "suggestInvestmentContracts", "suggestContactInvestor"]
  }),
  topic({
    id: "vip_investor",
    category: "role",
    icon: "vip",
    keywords: ["vip", "vip investor", "vip investisseur", "access vip", "acces vip", "accès vip", "premium investor"],
    responsibleRole: ["Investment", "Administrator", "Family"],
    suggestedQuestionKeys: ["suggestVipAccess", "suggestInvestmentProjects", "suggestContactInvestor"]
  }),
  topic({
    id: "administrator",
    category: "role",
    icon: "admin",
    keywords: ["admin", "administrator", "administrateur", "responsabilite", "responsabilité", "responsibilities", "become admin", "devenir admin"],
    responsibleRole: ["Administrator", "Family"],
    suggestedQuestionKeys: ["suggestAdminConditions", "suggestContactAdmin"]
  }),
  topic({
    id: "order",
    category: "commerce",
    icon: "shipping",
    keywords: ["order", "orders", "commande", "commandes", "passer commande", "track order", "suivre commande", "tracking", "modifier commande", "annuler commande", "cancel order", "ticket order", "retour commande", "replacement", "remplacement", "refund order", "remboursement commande"],
    responsibleRole: ["CustomerService", "Administrator", "Associate"],
    suggestedQuestionKeys: ["suggestTrackOrder", "suggestCancelOrder", "suggestOpenTicket", "suggestContactOrder"]
  }),
  topic({
    id: "payment",
    category: "commerce",
    icon: "payment",
    keywords: ["payment", "paiement", "card", "carte", "stripe", "wallet", "secure payment", "paiement securise", "paiement sécurisé", "declined", "refuse", "refusé", "invoice", "facture", "payout", "seller payout", "versement"],
    responsibleRole: ["CustomerService", "Administrator"],
    suggestedQuestionKeys: ["suggestPaymentDeclined", "suggestWallet", "suggestInvoice", "suggestContactSupport"]
  }),
  topic({
    id: "delivery",
    category: "commerce",
    icon: "delivery",
    keywords: ["delivery", "livraison", "shipping", "delai", "délai", "frais livraison", "address", "adresse", "carrier", "transporteur", "shippo", "usps"],
    responsibleRole: ["CustomerService", "Provider", "Administrator"],
    suggestedQuestionKeys: ["suggestDeliveryDelay", "suggestDeliveryAddress", "suggestContactOrder"]
  }),
  topic({
    id: "products",
    category: "commerce",
    icon: "products",
    keywords: ["product", "products", "produit", "produits", "search", "recherche", "favoris", "favorite", "compare", "comparaison", "promotion", "variant", "variante", "availability", "disponibilite", "disponibilité"],
    responsibleRole: ["Seller", "Provider", "Support"],
    suggestedQuestionKeys: ["suggestSearchProduct", "suggestCompareProducts", "suggestPromotions"]
  }),
  topic({
    id: "jobs",
    category: "opportunity",
    icon: "job",
    keywords: ["job", "jobs", "emploi", "emplois", "career", "carriere", "carrière", "recruitment", "recrutement", "apply", "postuler", "opportunity", "opportunite", "opportunité"],
    responsibleRole: ["Administrator", "Family"],
    suggestedQuestionKeys: ["suggestApplyJob", "suggestJobRoles", "suggestContactAdmin"]
  }),
  topic({
    id: "support",
    category: "support",
    icon: "support",
    keywords: ["support", "help", "aide", "faq", "ticket", "problem", "probleme", "problème", "signaler", "contact", "responsable", "agent", "humain", "personne"],
    responsibleRole: ["Support", "CustomerService", "Administrator"],
    suggestedQuestionKeys: ["suggestOpenTicket", "suggestContactSupport", "suggestSecurity"]
  }),
  topic({
    id: "security",
    category: "security",
    icon: "security",
    keywords: ["security", "securite", "sécurité", "2fa", "double authentication", "double authentification", "new device", "nouvel appareil", "blocked", "bloque", "bloqué", "suspicious", "suspect"],
    responsibleRole: ["Support", "Administrator"],
    suggestedQuestionKeys: ["suggestNewDevice", "suggestBlockedAccount", "suggestContactSupport"]
  }),
  topic({
    id: "legal",
    category: "legal",
    icon: "legal",
    keywords: ["legal", "juridique", "terms", "conditions", "privacy", "confidentialite", "confidentialité", "policy", "politique", "reglement", "règlement", "rules"],
    responsibleRole: ["Administrator", "Family"],
    suggestedQuestionKeys: ["suggestTerms", "suggestPrivacy", "suggestContactAdmin"]
  }),
  topic({
    id: "start",
    category: "guide",
    icon: "start",
    keywords: ["start", "begin", "commencer", "debuter", "débuter", "steps", "etapes", "étapes", "first step", "your step"],
    responsibleRole: ["Support", "Associate", "Administrator"],
    suggestedQuestionKeys: ["suggestRoleSteps", "suggestCreateAccount", "suggestContactSupport"]
  })
];

export const knowledgeById = supportKnowledgeBase.reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {});

knowledgeById.general = knowledgeById.elakay;
knowledgeById.admin = knowledgeById.administrator;
knowledgeById.job = knowledgeById.jobs;
knowledgeById.product = knowledgeById.products;

export const quickQuestions = [
  { key: "quickGeneral", topic: "elakay" },
  { key: "quickOrder", topic: "order" },
  { key: "quickSeller", topic: "seller" },
  { key: "quickProvider", topic: "provider" },
  { key: "quickAssociate", topic: "associate" },
  { key: "quickInvestor", topic: "investor" },
  { key: "quickVipInvestor", topic: "vip_investor" },
  { key: "quickContact", topic: "support", requestContact: true }
];

export const contactKeywords = [
  "contact",
  "contacter",
  "responsable",
  "personne",
  "agent",
  "humain",
  "support",
  "equipe",
  "équipe",
  "call",
  "phone",
  "email",
  "envoyer message"
];

const levenshteinDistance = (a = "", b = "") => {
  if (Math.abs(a.length - b.length) > 2) return 99;
  const matrix = Array.from({ length: a.length + 1 }, (_, i) => [i]);
  for (let j = 1; j <= b.length; j += 1) matrix[0][j] = j;
  for (let i = 1; i <= a.length; i += 1) {
    for (let j = 1; j <= b.length; j += 1) {
      matrix[i][j] = a[i - 1] === b[j - 1]
        ? matrix[i - 1][j - 1]
        : Math.min(matrix[i - 1][j - 1], matrix[i][j - 1], matrix[i - 1][j]) + 1;
    }
  }
  return matrix[a.length][b.length];
};

const scoreTopic = (topicItem, normalizedMessage, words) => {
  const keywords = (topicItem.keywords || []).map(normalizeSupportMessage).filter(Boolean);
  return keywords.reduce((score, keyword) => {
    if (normalizedMessage === keyword) return score + 12;
    if (normalizedMessage.includes(keyword)) return score + 8;
    const keywordWords = keyword.split(" ");
    const exactWordScore = keywordWords.some((word) => words.includes(word)) ? 4 : 0;
    const fuzzyWordScore = keywordWords.some((keywordWord) => (
      keywordWord.length >= 5 &&
      words.some((word) => word.length >= 5 && levenshteinDistance(word, keywordWord) <= 2)
    )) ? 2 : 0;
    return score + exactWordScore + fuzzyWordScore;
  }, 0);
};

const CONFIDENCE_THRESHOLD = 4;

/**
 * Comme detectSupportTopic, mais expose en plus le score de confiance afin
 * de savoir si la base de connaissances locale a vraiment une réponse
 * (confident: true) ou si elle ne fait que retomber sur un topic par défaut
 * (confident: false) — utilisé pour décider d'appeler l'assistant Gemini.
 */
export const matchSupportTopic = (message = "", contextTopicId = "") => {
  const normalized = normalizeSupportMessage(message);
  if (!normalized) {
    return { topic: knowledgeById[contextTopicId] || knowledgeById.elakay, score: 0, confident: false };
  }

  const words = normalized.split(" ").filter(Boolean);
  const ranked = supportKnowledgeBase
    .map((topicItem) => ({
      topic: topicItem,
      score: scoreTopic(topicItem, normalized, words) + (topicItem.id === contextTopicId ? 2 : 0)
    }))
    .sort((a, b) => b.score - a.score);

  if (ranked[0]?.score >= CONFIDENCE_THRESHOLD) {
    return { topic: ranked[0].topic, score: ranked[0].score, confident: true };
  }

  return {
    topic: knowledgeById[contextTopicId] || knowledgeById.elakay,
    score: ranked[0]?.score || 0,
    confident: false
  };
};

export const detectSupportTopic = (message = "", contextTopicId = "") =>
  matchSupportTopic(message, contextTopicId).topic;

export const isContactRequest = (message = "") => {
  const normalized = normalizeSupportMessage(message);
  return contactKeywords
    .map(normalizeSupportMessage)
    .some((keyword) => keyword && normalized.includes(keyword));
};
